"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-one/sections/servicesSection.tsx */

import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ServicesSectionServicesSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "Multi Speciality Treatments & Doctors" | "Lab Testing Services" | "Medecines & Supplies" | "Hospitals & Clinics" | "Health Care Services" | "Talk to Doctors" | "Home Care Services" */
    link0Text: ReactNode;
    /** Detected variants: "services-slide" */
    className?: string;
    /** Detected variants: "#" */
    href?: string;
};
export type HomeOneServicesSectionGeneratedProps = {
    divH60H6Props?: Partial<ComponentProps<"h6">> | ((item: ServicesSectionServicesSlidesItem) => Partial<ComponentProps<"h6">>);
    divH60Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ServicesSectionServicesSlidesItem) => Partial<ComponentProps<typeof SmartLink>>);
    /** Default: "1s" */
    sectionDataWowDuration?: string;
    /** Default: "right" */
    sectionDiv0DivDataDirection?: string;
    /** Default: "slow" */
    sectionDiv0DivDataSpeed?: string;
    servicesSectionServicesSlides: ServicesSectionServicesSlidesItem[];
    servicesSectionServicesSlidesItemWrapper?: (item: ServicesSectionServicesSlidesItem, content: ReactNode) => ReactNode;
    servicesSectionServicesSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    servicesSectionServicesSlidesLinkVisible?: boolean;
    servicesSectionServicesSlidesLinkRenderer?: (item: ServicesSectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    servicesSectionServicesSlidesH6Visible?: boolean;
    servicesSectionServicesSlidesH6Renderer?: (item: ServicesSectionServicesSlidesItem, defaultNode: ReactNode) => ReactNode;
    servicesSectionServicesSlidesLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ServicesSectionServicesSlidesItem) => Partial<ComponentProps<typeof SmartLink>>);
    servicesSectionServicesSlidesH6Props?: Partial<ComponentProps<"h6">> | ((item: ServicesSectionServicesSlidesItem) => Partial<ComponentProps<"h6">>);
};

const HomeOneServicesSectionGenerated: FC<HomeOneServicesSectionGeneratedProps> = ({
    sectionDataWowDuration = "1s",
    sectionDiv0DivDataDirection = "right",
    sectionDiv0DivDataSpeed = "slow",
    divH60H6Props,
    divH60Link0LinkProps,
    servicesSectionServicesSlides,
    servicesSectionServicesSlidesItemWrapper,
    servicesSectionServicesSlidesRenderer,
    servicesSectionServicesSlidesLinkVisible,
    servicesSectionServicesSlidesLinkRenderer,
    servicesSectionServicesSlidesH6Visible,
    servicesSectionServicesSlidesH6Renderer,
    servicesSectionServicesSlidesLinkProps,
    servicesSectionServicesSlidesH6Props,
}) => {
    return (
        <section className="services-section wow fadeOutDown" data-wow-duration={sectionDataWowDuration}>
            <div className="horizontal-slide d-flex" data-direction={sectionDiv0DivDataDirection} data-speed={sectionDiv0DivDataSpeed}>
                <div className="slide-list d-flex gap-4">
                    {renderCollectionNode(
                        servicesSectionServicesSlides,
                        (item: ServicesSectionServicesSlidesItem) => (
                            <div className={item.className ?? "services-slide"} key={item.key}>
                                {renderItemNode(servicesSectionServicesSlidesH6Visible, servicesSectionServicesSlidesH6Renderer, item, (
                                    <h6 {...(typeof servicesSectionServicesSlidesH6Props === "function" ? servicesSectionServicesSlidesH6Props(item) : (servicesSectionServicesSlidesH6Props ?? {}))} {...(typeof divH60H6Props === "function" ? divH60H6Props(item) : (divH60H6Props ?? {}))}>
                                        {renderItemNode(servicesSectionServicesSlidesLinkVisible, servicesSectionServicesSlidesLinkRenderer, item, (
                                            <SmartLink href={item.href ?? "#"} {...(typeof servicesSectionServicesSlidesLinkProps === "function" ? servicesSectionServicesSlidesLinkProps(item) : (servicesSectionServicesSlidesLinkProps ?? {}))} {...(typeof divH60Link0LinkProps === "function" ? divH60Link0LinkProps(item) : (divH60Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                        ))}
                                    </h6>
                                ))}
                            </div>
                        ),
                        servicesSectionServicesSlidesItemWrapper,
                        servicesSectionServicesSlidesRenderer
                    )}
                </div>
            </div>
        </section>
    );
};

export default HomeOneServicesSectionGenerated;
